import React, { useEffect } from "react";
import {
  Chip,
  Accordion, AccordionDetails, AccordionSummary,
  Grid,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams } from "react-router-dom";
import { GetDexInfoSpecific } from "../utils/GetCustomer";
import { useLocalStorage } from "../componentUtils/LocalStorage";
import { DexDashbord } from "src/pages/Telemetry/DexDashbord";

interface CustomerRouteParams {
  identifier: string;
}

interface DexState {
  isLoaded: boolean,
  dexInfo: any,
  dexArr: any,
  dexDesc: any,
  dexMsg: any,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    dexContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    errorContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    chipActual: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },
  })
);

export default function DexInfo(params:{DeliveryPlant:string|undefined}) {
  let DeliveryPlant = params.DeliveryPlant||'';
  const routeParams = useParams<CustomerRouteParams>();
  const classes = useStyles();
  const theme = useTheme();
  const [state, setState] = React.useState<DexState>({
    isLoaded: false,
    dexInfo: {},
    dexArr: [],
    dexDesc: [],
    dexMsg: [],
  });

  const [is_telemetry, setIsTelemetry] = React.useState(false)



  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const valid = state?.dexInfo?.valid === 'true'
  const parseDex = (dexfile: string): any => {
    var dexArr = [];
    const lines = dexfile.split("\n");
    for (var i:number = 0; i<lines.length; i++) {
      const line = lines[i];
      const items = line.split("*");
      if (items.length > 1) {
        const ri = items[0].toUpperCase();
        for (var j:number = 1; j<items.length; j++) {
          if (items[j].length > 0) {
            const ident = ri + String(j).padStart(2, "0");
            const elem = {id: ident, value: items[j]};
            dexArr.push(elem);
          }
        }
      }
    }
    return dexArr;
  };

  const convertPeriod = (period: number): string => {
    const DAY = (24 * 60 * 60);
    const HR = (60 * 60);
    const MIN = 60;
    var remaining = period;
    var outStr = "";
    const days = Math.floor(remaining / DAY);
    remaining -= days * DAY;
    const hours = Math.floor(remaining / HR);
    remaining -= hours * HR;
    const mins = Math.floor(remaining / MIN);
    remaining -= mins * MIN;
    const seconds = remaining;
    if (days) {
      outStr = outStr + days + "d ";
    }
    if (hours) {
      outStr = outStr + hours + "h ";
    }
    if (mins) {
      outStr = outStr + mins + "m ";
    }    
    if (seconds) {
      outStr = outStr + seconds + "s";
    }
    return outStr;
  }

  useEffect(() => {
    if (state.isLoaded) return;

     GetDexInfoSpecific(salesOrg.toString(), routeParams.identifier).then(
      (v: any) => {
        let lk: any = [];
        let dexarr: any = [];
        let dexinfo: any = {};
        let dexmsg: any = [];

        if (v?.dexfields && v?.dexfile) {
          if (v?.dexfile?.last_tx_dex_data) {
            const dexfields = v.dexfields;
            const dexfile: string = v.dexfile.last_tx_dex_data;
            dexfields.map((elem: any) => {
              lk[elem.code] = elem.textLong;
            });
            dexarr = parseDex(dexfile);
          }
          dexinfo = v.dexfile;
          dexmsg = v.dexMessages;
        }

        setState({
          ...state,
          isLoaded: true,
          dexDesc: lk,
          dexArr: dexarr,
          dexInfo: dexinfo,
          dexMsg: dexmsg,
        });

        setIsTelemetry(v.is_telemetry)
      }
    );
  }, [state, routeParams.identifier]);

  if (!state.isLoaded)
    return <div style={{textAlign:"center"}}>Loading...</div>;

  if (!state.dexInfo)
    return <div>No DEX Data available</div>;

  var dexErrors = [];
  if (state.dexInfo.errors && state.dexInfo.errors !== "") {
    dexErrors = state.dexInfo.errors.split(",");
  }

  var dexSource = "VDI";
  if (state.dexInfo.last_tx_dex_source === "D") {
    dexSource = "VM-DEX";
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={2} className={classes.gridMarginTop}>
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Device ID"
            value={valid ? state.dexInfo.device_id : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Cashless Serial"
            value={valid ? state.dexInfo.da101 : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Last Fill Event"
            value={valid ? state.dexInfo.last_fill_dex_dt : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Last Scheduled DEX Event"
            value={valid ? state.dexInfo.last_tx_dex_dt : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Last Transmission"
            value={valid ? state.dexInfo.last_transmission_dt : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Transmission Period"
            value={valid ? convertPeriod(state.dexInfo.last_transmission_period) : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>                   
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="DEX Source"
            value={valid ? dexSource : ''}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid> 
        <Grid item xs={3} lg={3} className={classes.gridSpaceable}>
          <TextField
            fullWidth={true}
            label="Sub Serial Number"
            value={state.dexInfo.sub_serial_num}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>                    
      </Grid>
      <br></br>
      {is_telemetry==true? <DexDashbord DeliveryPlant = {DeliveryPlant}/>:
    <> {dexErrors.length > 0 &&
      <div className={classes.errorContainer}>
      <Chip
        label="Dex Errors"
        className={classes.chipActual}
        color="primary"
      />
      {
        valid && (
          <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Error Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dexErrors.map((item: any, index: number) => {
              const errorKey = item.split('-')[0];
              const desc = state.dexMsg.find((elem: { message_code: string; }) => elem.message_code === errorKey);
              var description = "";
              var isImportant = false;
              if (desc) {
                description = desc.message_description;
                isImportant = desc.is_important;
              }
              return (
                <TableRow key={index} selected={isImportant}>
                <TableCell>{item}</TableCell>
                <TableCell>{description}</TableCell>    
              </TableRow>     
              );
            }
            )}
          </TableBody>
        </Table>
      </TableContainer>
        )
      }
      </div>
    } 
        
       <Accordion className={classes.dexContainer}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}
          area-control="dexpanel-content"
          id="dexpanel-header" >
          <Typography>DEX Data</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{width: "50%"}}>Segment</TableCell>
              <TableCell style={{width: "50%"}}>Value</TableCell>   
            </TableRow>
          </TableHead>
          <TableBody>
            {state?.dexInfo?.valid === 'true' && state.dexArr.map((item: any, index: number) => {
              const desc = state.dexDesc[item.id] || "";
              return (
                <TableRow key={index}>
                <TableCell style={{width: "50%"}}>{item.id + ": " + desc}</TableCell>
                <TableCell style={{width: "50%"}}>{item.value}</TableCell>    
              </TableRow>   
              );
            }         
            )}
          </TableBody>
        </Table>
      </TableContainer>
        </AccordionDetails>  
      </Accordion>  </>}
    </div>
  );
}
